export default defineNuxtRouteMiddleware((to, _from) => {
  try {
    const { isLoginStatus } = storeToRefs(useAuthStore())
    if (!isLoginStatus.value) {
      const { isApp } = useAppCheck()
      if (isApp) {
        const { redirectPath } = storeToRefs(useRedirectStore())
        redirectPath.value = to.fullPath
        window.flutter_inappwebview.callHandler('onLoginRequired', {
          returnUrl: redirectPath.value
        })
        return navigateTo('/')
      }
      const partnersKey = to.params.partner
      const returnUrl = encodeURIComponent(to.fullPath)
      return partnersKey
        ? navigateTo(`/partners/${partnersKey}/user/login?returnUrl=${returnUrl}`)
        : navigateTo(`/user/login?returnUrl=${returnUrl}`)
    }
  } catch (e) {
    console.warn('An error occured on Auth middleware', e)
  }
})
